/**
 * Returns a round number value with specified precision
 *
 * @param value - passed value
 * @param precision - rounding precision
 * @returns round number value
 */
export const roundNumber = (value, precision) => (Math.round((value + Number.EPSILON) * Math.pow(10, precision)) / Math.pow(10, precision));
